import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// NotFound用の空コンポーネント
// 想定外pathに遷移した場合、TOPに遷移させる。
export const NotFound = () => {
    const navigation = useNavigate();

    useEffect(() => {
        navigation('/');
    }, []);

    return <></>;
};
